import { createDspFxNode } from './dspModule';
import { dspAssetUrl } from './dspAssetUrl';

const WORKLET_URL = dspAssetUrl('/audio/reverbProcessor.js');
const workletLoads = new WeakMap();

export function createReverbNode(context, params = {}) {
  return createDspFxNode(context, {
    workletUrl: WORKLET_URL, processorName: 'cookup-reverb', params, workletLoads
  });
}

export const sendReverbParams = (node, params) => {
  node?.port?.postMessage({ type: 'params', params });
};

export const resetReverb = (node) => {
  node?.port?.postMessage({ type: 'reset' });
};
